export default {
    branch: 'Branch',
    searchBranches: 'Search Branches',
    search: 'Search',
    branchName: 'Branch Name',
    branchAddress: 'Branch Address',
    contactPerson: 'Contact Person',
    action: 'Action',
    createBranch: 'Create Branch',
    congratulation: 'Congratulation',
    errorMessage: 'Error Message',
    deleteBranch: 'Delete Branch',
    wantToDelete: 'Are you sure you want to delete',
    branchIsDeleted: 'Branch is deleted'
}
